import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/gallery-category`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchGalleryCategories = (payload) => apiHelper(API_URL, 'GET', payload);
export const createGalleryCategory = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchGalleryCategory = (categoryId) => apiHelper(`${API_URL}/${categoryId}`, 'GET');
export const modifyGalleryCategory = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteGalleryCategoryApi = (categoryId) => apiHelper(`${API_URL}/${categoryId}`, 'DELETE');
export const getAllCategoriesApi = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/admin/get-all-gallery-categories`, 'GET', payload);
export const getChildCategoriesApi = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/admin/get-child-categories`, 'GET', payload);
export const getCategoryAttributesApi = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/admin/get-category-attributes`, 'GET', payload);
export const changeStatus = (categoryId) => apiHelper(`${API_URL}/change-status/${categoryId}`, 'POST');